import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useStyledBlock, StyleControls } from "./StyleControls";
import type { BlockSettingsTabProps } from "./BreakpointSwitcher";

type HtmlProps = { html: string };

export function HtmlEmbedBlockSettings({ tab, breakpoint }: BlockSettingsTabProps) {
  const { props, setProp, style, updateStyle } = useStyledBlock<HtmlProps>();

  if (tab === "content") {
    return (
      <div className="space-y-1">
        <Label className="text-xs">HTML (sanitized on render)</Label>
        <Textarea
          className="font-mono text-xs"
          rows={6}
          value={props.html ?? ""}
          onChange={(e) => setProp((p) => { p.html = e.target.value; })}
        />
      </div>
    );
  }
  if (tab === "style") {
    return <StyleControls style={style} updateStyle={updateStyle} breakpoint={breakpoint} />;
  }
  return null;
}
